module.exports = __webpack_public_path__ + "img/MSUwordmark.4b94b15d.png";